/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEmployeeLogModel as DigiworkMaitreDPosDtoEmployeeUpdateEmployeeLogModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/update-employee-log-model';

export interface UpdateEmployeeLog$Params {
      body?: DigiworkMaitreDPosDtoEmployeeUpdateEmployeeLogModel
}

export function updateEmployeeLog(http: HttpClient, rootUrl: string, params?: UpdateEmployeeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateEmployeeLog.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateEmployeeLog.PATH = '/api/mng/Employee/updateemployeelog';
